import http from '@/utils/http';

const baseUrl = '/rastreabilidade/visao-fazenda';

export default {
    buscarPorFazenda(codigoFazenda) {
        let url =
            baseUrl + '/buscar-por-fazenda' + '?codigo-fazenda=' + codigoFazenda;

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Dados da Fazenda'
        });
    }
};
